module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-start-selling-armchair@2x-9076ee5fb98692738a8780d7c295cc2c.png";